'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002467 from "./presto.-Credentials-View$$anon$67.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002469 from "./presto.-Credentials-View$$anon$69.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002475 from "./presto.-Credentials-View$$anon$75.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsage$002dItem$0024 from "./presto.types$-Credential-Usage-Item$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$66(outer) {
  this.aHF = null;
  this.aHx = null;
  this.aHy = false;
  this.aHG = null;
  this.aHH = false;
  this.aHK = null;
  this.aHD = null;
  this.aHE = false;
  this.aHz = null;
  this.aHA = false;
  this.aHB = null;
  this.aHC = false;
  this.aHI = false;
  this.aHJ = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aHF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aHK = "CredentialUsageItem";
}
export { $c_Lpresto_CredentialsView$$anon$66 as $c_Lpresto_CredentialsView$$anon$66 };
$p = $c_Lpresto_CredentialsView$$anon$66.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$66;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$66() {
}
export { $h_Lpresto_CredentialsView$$anon$66 as $h_Lpresto_CredentialsView$$anon$66 };
$h_Lpresto_CredentialsView$$anon$66.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aHF;
});
$p.M = (function() {
  if ((!this.aHy)) {
    this.aHx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aHy = true;
  }
  return this.aHx;
});
$p.O = (function() {
  if ((!this.aHH)) {
    this.aHG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aHH = true;
  }
  return this.aHG;
});
$p.E = (function() {
  return this.aHK;
});
$p.t = (function() {
  if ((!this.aHE)) {
    this.aHD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("secret", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("usage", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aHE = true;
  }
  return this.aHD;
});
$p.N = (function() {
  if ((!this.aHA)) {
    this.aHz = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002467.$c_Lpresto_CredentialsView$$anon$67(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002469.$c_Lpresto_CredentialsView$$anon$69())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aHA = true;
  }
  return this.aHz;
});
$p.Q = (function() {
  if ((!this.aHC)) {
    this.aHB = new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002475.$c_Lpresto_CredentialsView$$anon$75();
    this.aHC = true;
  }
  return this.aHB;
});
$p.v = (function() {
  if ((!this.aHJ)) {
    this.aHI = false;
    this.aHJ = true;
  }
  return this.aHI;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee224) => ((p) => \u03b4scrutinee224.cFL(p)))($j_presto$002etypes$0024$002dCredential$002dUsage$002dItem$0024.$m_Lpresto_types$CredentialUsageItem$())));
});
var $d_Lpresto_CredentialsView$$anon$66 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$66, "presto.CredentialsView$$anon$66", ({
  Gv: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$66 as $d_Lpresto_CredentialsView$$anon$66 };
//# sourceMappingURL=presto.-Credentials-View$$anon$66.js.map
